// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { gridTwoByTwo16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-grid-two-by-two': IconGridTwoByTwo;
    }
}

/**
 * The icon component for the 'gridTwoByTwo' icon
 */
export class IconGridTwoByTwo extends IconSvg {
    public constructor() {
        super(gridTwoByTwo16X16);
    }
}

registerIconSvg('icon-grid-two-by-two', IconGridTwoByTwo);
export const iconGridTwoByTwoTag = 'nimble-icon-grid-two-by-two';
